import { RequireOnly } from '@pelicargo/types';
import { Quote, QuoteSource } from '@prisma/client';

/** Builds a link to the quote in the source integration's own UI, from its `integration_order_id`. */
const INTEGRATION_URL_BUILDERS: Partial<Record<QuoteSource, (orderId: string) => string>> = {
  // NextGen quotes keep their CUDA quote id as the order id
  [QuoteSource.NEXTGEN]: (orderId) =>
    `https://customer.cudacartagetms.com/quotes/edit?id=${encodeURIComponent(orderId)}`,
};

/** A link to the quote in the integration it was sourced from, when that integration has one. */
export const integrationUrl = (quote?: RequireOnly<Quote, 'sourced_by' | 'integration_order_id'> | null) => {
  if (!quote?.sourced_by || !quote?.integration_order_id) return undefined;
  return INTEGRATION_URL_BUILDERS[quote.sourced_by]?.(quote.integration_order_id);
};
